import type { QueryClient } from '@tanstack/react-query';

export const HOMEPAGE_DRAFT_QUERY_KEY = ['homepage', 'draft'] as const;
export type HomepageDraftInput = { issuePrompt: string };

export async function createDraft(
	input: HomepageDraftInput,
	{ queryClient }: { queryClient: QueryClient },
): Promise<HomepageDraftInput> {
	// Set query defaults for caching behavior between page transitions
	// 10 minutes gcTime allows for navigation while keeping the cache reasonable
	queryClient.setQueryDefaults(HOMEPAGE_DRAFT_QUERY_KEY, {
		gcTime: 600_000, // 10 minutes
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
	queryClient.setQueryData(HOMEPAGE_DRAFT_QUERY_KEY, input);

	return Promise.resolve(input);
}
